import React, { useCallback } from "react";
import locale from "./videoDisplay.locale";
function VideoDisplay(props) {
    const { currentTrack, mediaRef, widthVideoClip, heightVideoClip, handleLoadedMetaData } = props;
    const handleError = useCallback(() => {
        props.showError && props.showError(locale.LOAD_VIDEO_FAILED);
    }, [props.showError]);
    return (React.createElement("video", { ref: mediaRef, onLoadedMetadata: handleLoadedMetaData, onError: handleError, width: widthVideoClip, height: heightVideoClip },
        React.createElement("source", { src: currentTrack })));
}
export default VideoDisplay;
